import { ExternalLink, MoreHorizontal, UserPlus } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { ExpandingIconButton } from '@/components/ui/expanding-icon-button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import { connectionTypeName } from '../connections/types'
import type { UnmatchedItem } from './types'

export function vendorUrl(row: UnmatchedItem) {
  return row.source_url && /^https?:\/\//i.test(row.source_url) ? row.source_url : undefined
}
export function VendorLink({ row }: { row: UnmatchedItem }) {
  const href = vendorUrl(row)
  if (!href) return null
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Open ${row.name_snapshot} in ${connectionTypeName(row.connection_type)}`}
      className="inline-flex text-muted-foreground hover:text-foreground"
    >
      <ExternalLink className="size-4" strokeWidth={1.5} />
    </a>
  )
}
export function QueueActions({
  row,
  pending,
  onLink,
  onAction,
  onIgnore,
}: {
  row: UnmatchedItem
  pending: boolean
  onLink: (row: UnmatchedItem) => void
  onAction: (row: UnmatchedItem, action: string) => void
  onIgnore: (row: UnmatchedItem) => void
}) {
  if (row.status === 'ignored')
    return (
      <Button variant="outline" disabled={pending} onClick={() => onAction(row, 'unignore')}>
        Un-ignore
      </Button>
    )
  if (row.status !== 'open') return null
  return (
    <div className="flex items-center justify-end gap-2">
      <Button variant="outline" disabled={pending} onClick={() => onLink(row)}>
        Link
      </Button>
      <ExpandingIconButton
        icon={UserPlus}
        label="Create contact"
        disabled={pending}
        onClick={() => onAction(row, 'create_contact')}
      />
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" aria-label={`${row.name_snapshot} actions`}>
            <MoreHorizontal className="size-4" strokeWidth={1.5} />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem disabled={pending} onSelect={() => onIgnore(row)}>
            Ignore
          </DropdownMenuItem>
          {vendorUrl(row) && (
            <DropdownMenuItem asChild>
              <a href={vendorUrl(row)} target="_blank" rel="noopener noreferrer">
                Open in {connectionTypeName(row.connection_type)}
              </a>
            </DropdownMenuItem>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
